import $I18n from '@videotools/js/i18n';

// Key for unknown position
export const UNKNOWN = 'unknown';

// Sort by player number, delete empty arrays, translate keys
export const sortCleanTranslate = (playerPositionMap, sportName) => {
	const sortOrder = Object.keys(playerPositionMap);

	return sortOrder.reduce(
		(obj, key) => {
			if (playerPositionMap[key] && Array.isArray(playerPositionMap[key]) && playerPositionMap[key].length) {
				const translatedKey = key !== UNKNOWN ? $I18n.trans(`sports.${sportName}.positions.${key}`) : UNKNOWN;
				obj[translatedKey] = playerPositionMap[key].sort((a, b) => (+a.number > +b.number) ? 1 : -1);
			}
			return obj;
		},
		{}
	);
};

export const populatePlayerPositionMap = (playerPositionMap, players) => {
	players?.forEach((player) => {
		const position = player?.position?.name;
		if (!position) playerPositionMap[UNKNOWN].push(player);
		else if (!playerPositionMap[position]) throw new Error(`Position ${position} not defined in the map`);
		else playerPositionMap[position].push(player);
	});
};
